class SptebikReveal {
  constructor() {
    this.items = [...document.querySelectorAll('[data-spt-reveal]')];
    this.observer = null;
  }

  connect() {
    if (this.items.length === 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (const item of this.items) item.classList.add('is-visible');
      return;
    }

    document.documentElement.classList.add('spt-reveal-ready');
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08,
    });
    for (const item of this.items) this.observer.observe(item);
  }

  onIntersect(entries) {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-visible');
      this.observer?.unobserve(entry.target);
    }
  }
}

new SptebikReveal().connect();
